type Adresse = { street?: string; houseNumber?: string; zip?: string; city?: string; country?: string }
const s = (v: unknown): string => (v == null ? '' : String(v).trim())
export const formatStreetLine = (a: Adresse): string => [s(a.street), s(a.houseNumber)].filter(Boolean).join(' ')
export const buildMapsDestination = (a: Adresse): string =>
  [formatStreetLine(a), [s(a.zip), s(a.city)].filter(Boolean).join(' ')].filter(Boolean).join(', ')
/** vCard 3.0 ADR: pobox;ext;street;locality;region;postal;country */
export const buildVcfAdr = (a: Adresse): string =>
  `;;${formatStreetLine(a)};${s(a.city)};;${s(a.zip)};${s(a.country)}`
